(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["almeora-catalogue-card"] && !Shopify.designMode) return;
  try {
    if(!window.almeoraCardPressReady){window.almeoraCardPressReady=true;let pressed=null;const clearPress=()=>{if(pressed){pressed.classList.remove('is-touch-pressed');pressed=null;}};document.addEventListener('pointerdown',event=>{clearPress();if(event.pointerType==='mouse'||event.isPrimary===false)return;const card=event.target.closest('.alm-product-link');if(card){pressed=card;pressed.classList.add('is-touch-pressed');}},{passive:true});['pointerup','pointercancel','pointermove'].forEach(name=>document.addEventListener(name,clearPress,{passive:true}));document.addEventListener('pointerleave',event=>{if(pressed&&event.target===pressed)clearPress();},true);document.addEventListener('pointerout',event=>{if(pressed&&!pressed.contains(event.relatedTarget))clearPress();},{passive:true});window.addEventListener('blur',clearPress);window.addEventListener('pageshow',clearPress);document.addEventListener('visibilitychange',clearPress);}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["almeora-film"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('almeora-image-film'))customElements.define('almeora-image-film',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;
    this.ready=true;
    this.stage=this.querySelector('.alm-scroll-film-stage');
    this.runway=this.querySelector('.alm-film-runway');
    this.scrollImage=this.querySelector('[data-scroll-image]');
    this.frames=Array.from(this.querySelectorAll('[data-frame]'));
    this.captions=Array.from(this.querySelectorAll('[data-caption]'));
    this.motion=matchMedia('(prefers-reduced-motion: reduce)');
    this.images=new Map();
    this.queue=[];
    this.loading=0;
    this.queued=false;
    this.shown=0;
    this.progress=0;
    this.visible=false;
    this.raf=0;
    this.abort=new AbortController();
    const opts={signal:this.abort.signal};
    this.schedule=()=>{
      if(this.raf||!this.visible||document.hidden)return;
      this.raf=requestAnimationFrame(()=>{this.raf=0;this.update();});
    };
    this.measure=()=>{
      const header=document.querySelector('sticky-header');
      const headerHeight=header?header.getBoundingClientRect().height:96;
      const available=Math.max(180,window.innerHeight-headerHeight-40);
      const height=Math.min(this.runway.clientWidth,760,window.innerHeight*.72,available);
      const offset=headerHeight+Math.max(16,(window.innerHeight-headerHeight-height)/2);
      this.style.setProperty('--film-height',height+'px');
      this.style.setProperty('--film-offset',offset+'px');
      this.schedule();
    };
    if(this.scrollImage){
      this.firstUrl=this.scrollImage.getAttribute('src');
      this.scrollImage.addEventListener('error',()=>{this.scrollImage.style.visibility='hidden';},opts);
      this.scrollImage.addEventListener('load',()=>{this.scrollImage.style.visibility='visible';},opts);
    }
    this.syncMotion=()=>{
      this.toggleAttribute('data-scroll-ready',!this.motion.matches);
      if(this.motion.matches){
        if(this.scrollImage){this.scrollImage.src=this.firstUrl;this.shown=0;}
        this.setPanels(0);
      }else{this.prepare();this.schedule();}
    };
    window.addEventListener('scroll',this.schedule,{...opts,passive:true});
    window.addEventListener('resize',this.measure,{...opts,passive:true});
    window.addEventListener('pageshow',this.schedule,opts);
    document.addEventListener('visibilitychange',this.schedule,opts);
    this.motion.addEventListener('change',this.syncMotion,opts);
    this.observer=new IntersectionObserver(entries=>{
      this.visible=entries[0].isIntersecting;
      if(this.visible){this.prepare();this.schedule();}
    },{rootMargin:'600px 0px'});
    this.observer.observe(this.runway);
    this.resizeObserver=new ResizeObserver(this.measure);
    this.resizeObserver.observe(this.runway);
    this.measure();
    this.syncMotion();
  }
  frameUrl(index){return this.firstUrl.replace(/almeora-nuage-scroll-\d{2}\.webp/,'almeora-nuage-scroll-'+String(index+1).padStart(2,'0')+'.webp');}
  prepare(){
    if(!this.scrollImage||!this.visible||this.motion.matches)return;
    if(!this.queued){this.queued=true;this.queue=Array.from({length:36},(_,i)=>i);}
    this.loadFrames();
  }
  loadFrames(){
    if(!this.ready||!this.visible||this.motion.matches)return;
    while(this.loading<3&&this.queue.length){
      const index=this.queue.shift();
      if(this.images.has(index))continue;
      const img=new Image();
      const record={image:img,ready:false};
      const signal=this.abort.signal;
      this.images.set(index,record);
      this.loading++;
      const finish=success=>{
        if(signal.aborted)return;
        record.ready=success;
        this.loading--;
        this.schedule();this.loadFrames();
      };
      img.onload=()=>{if(img.decode)img.decode().then(()=>finish(true),()=>finish(true));else finish(true);};
      img.onerror=()=>finish(false);
      img.decoding='async';
      img.src=this.frameUrl(index);
    }
  }
  showFrame(progress){
    const target=Math.round(progress*35);
    if(!this.images.has(target)){
      this.queue=this.queue.filter(index=>index!==target);
      this.queue.unshift(target);this.loadFrames();
    }
    let nearest=-1;
    this.images.forEach((record,index)=>{if(record.ready&&(nearest<0||Math.abs(index-target)<Math.abs(nearest-target)))nearest=index;});
    if(nearest>=0&&nearest!==this.shown){
      this.scrollImage.src=this.images.get(nearest).image.src;
      this.shown=nearest;
    }
  }
  setPanels(progress){
    const position=progress*Math.max(0,this.frames.length-1);
    const current=Math.round(position);
    this.frames.forEach((frame,index)=>{
      frame.style.opacity=String(Math.max(0,1-Math.abs(index-position)));
      frame.setAttribute('aria-hidden',String(index!==current));
    });
    const active=this.frames[current]?.dataset.frame;
    this.captions.forEach(caption=>caption.hidden=caption.dataset.caption!==active);
  }
  update(){
    if(!this.visible||this.motion.matches||document.hidden)return;
    const rect=this.runway.getBoundingClientRect();
    const offset=parseFloat(getComputedStyle(this).getPropertyValue('--film-offset'))||0;
    const distance=Math.max(1,rect.height-this.stage.clientHeight);
    this.progress=Math.min(1,Math.max(0,(offset-rect.top)/distance));
    if(this.scrollImage)this.showFrame(this.progress);else this.setPanels(this.progress);
  }
  disconnectedCallback(){
    this.ready=false;
    cancelAnimationFrame(this.raf);
    this.observer?.disconnect();this.resizeObserver?.disconnect();this.abort?.abort();
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["almeora-hero-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{const button=event.target.closest('[data-gallery-dir]');if(!button)return;const gallery=button.closest('.alm-hero-gallery'),track=gallery.querySelector('.slides'),slides=[...track.children];const x=track.getBoundingClientRect().left;let index=slides.reduce((best,slide,i)=>Math.abs(slide.getBoundingClientRect().left-x)<Math.abs(slides[best].getBoundingClientRect().left-x)?i:best,0);index=Math.max(0,Math.min(slides.length-1,index+Number(button.dataset.galleryDir)));track.scrollTo({left:slides[index].offsetLeft-slides[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})});
function almeoraGalleryInit(){document.querySelectorAll('.alm-hero-gallery').forEach(gallery=>{if(gallery.dataset.ready)return;gallery.dataset.ready='true';const track=gallery.querySelector('.slides'),slides=[...track.children],counter=gallery.querySelector('[data-gallery-count]');const update=()=>{let index=0,delta=Infinity;slides.forEach((slide,i)=>{const d=Math.abs(slide.getBoundingClientRect().left-track.getBoundingClientRect().left);if(d<delta){delta=d;index=i}});counter.textContent=(index+1)+' / '+slides.length;const ratio=Number(slides[index].dataset.ratio)||1;track.style.height=(track.clientWidth/ratio)+'px'};let frame;track.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(update)},{passive:true});track.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();gallery.querySelector('[data-gallery-dir="'+(event.key==='ArrowRight'?'1':'-1')+'"]').click()}});new ResizeObserver(update).observe(track);update()})}almeoraGalleryInit();document.addEventListener('shopify:section:load',almeoraGalleryInit);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["almeora-related-carousel"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = (scope = document) => {
    scope.querySelectorAll('.alm-related').forEach(carousel => {
      if (carousel.dataset.ready) return;
      carousel.dataset.ready = 'true';
      const track = carousel.querySelector('.alm-related-track');
      const previous = carousel.querySelector('[data-related-direction="-1"]');
      const next = carousel.querySelector('[data-related-direction="1"]');
      const update = () => {
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      carousel.querySelectorAll('[data-related-direction]').forEach(button => button.addEventListener('click', () => {
        const card = track.querySelector('.alm-related-card');
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
        track.scrollBy({left: Number(button.dataset.relatedDirection) * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }));
      track.addEventListener('scroll', update, {passive:true});
      new ResizeObserver(update).observe(track);
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["almeora-room-guide"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('almeora-room-calculator'))customElements.define('almeora-room-calculator',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.querySelector('form').addEventListener('submit',e=>{e.preventDefault();this.calculate();});this.querySelectorAll('input').forEach(x=>x.addEventListener('input',()=>{this.querySelector('[data-room-results]').hidden=true;this.querySelector('[data-room-status]').textContent='';this.querySelector('[data-plan]').hidden=true;this.querySelector('[data-plan-caption]').hidden=false;}));}
calculate(){const get=n=>Number(this.querySelector('[name='+n+']').value),rw=get('room_width'),rl=get('room_length'),bw=get('bed_width'),bl=get('bed_length');const status=this.querySelector('[data-room-status]'),results=this.querySelector('[data-room-results]'),plan=this.querySelector('[data-plan]');if(![rw,rl,bw,bl].every(x=>Number.isFinite(x)&&x>0&&x<=2000)){status.textContent=this.dataset.roomError;results.hidden=true;plan.hidden=true;return;}const side=(rw-bw)/2,foot=rl-bl;const format=x=>new Intl.NumberFormat(document.documentElement.lang||'fr',{maximumFractionDigits:1}).format(x)+' cm';this.querySelector('[data-side]').textContent=format(side);this.querySelector('[data-foot]').textContent=format(foot);results.hidden=false;const fits=side>=0&&foot>=0;status.textContent=fits?this.dataset.roomFit:this.dataset.roomFail;plan.hidden=!fits;this.querySelector('[data-plan-caption]').hidden=fits;if(fits){plan.style.aspectRatio=rw+'/'+rl;plan.style.maxWidth=Math.min(440,430*rw/rl)+'px';this.querySelector('.alm-plan-wall').hidden=true;const bed=this.querySelector('[data-bed]');bed.style.width=(bw/rw*100)+'%';bed.style.height=(bl/rl*100)+'%';bed.style.left=(side/rw*100)+'%';bed.style.top='0';this.querySelector('[data-side-label]').textContent=side/rw>.12?format(side):'';this.querySelector('[data-foot-label]').textContent=foot/rl>.15?format(foot):'';}}
});
  } catch(e) { console.error(e); }
})();

})();
